import { render, staticRenderFns } from "./NormalSearchNav270.vue?vue&type=template&id=890da4ac&scoped=true&"
import script from "./NormalSearchNav270.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav270.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890da4ac",
  null
  
)

export default component.exports